import { get, deleteRequest, post, patch } from 'utils/api';

export const getFleetUserGroupPricing = (data) => {
  return get(`/fleetUserGroupTariff`, data);
};

export const addFleetUserGroupPricing = (data) => {
  return post(`/fleetUserGroupTariff`, data);
};

export const updateFleetUserGroupPricing = (data) => {
  const id = data.id;
  delete data['id'];
  return patch(`/fleetUserGroupTariff/${id}`, data);
};

export const deleteFleetUserGroupPricing = (id) => {
  return deleteRequest(`/fleetUserGroupTariff/${id}`);
};

export const getFleetUserGroupPricingById = (id) => {
  return get(`/fleetUserGroupTariff/${id}`);
};

export const fleetUserGroupPricing = {
  getFleetUserGroupPricing,
  addFleetUserGroupPricing,
  updateFleetUserGroupPricing,
  deleteFleetUserGroupPricing,
  getFleetUserGroupPricingById,
};
